export type Testimonial = {
  quote: string;
  name: string;
  role: string;
  rating: number;
};

/** Verified client reviews published on Exec9's Clutch profile (clutch.co/profile/exec9). */
export const TESTIMONIALS: Testimonial[] = [
  {
    quote:
      "I'm impressed with the amount of time and effort Exec9 puts into delivering a quality product.",
    name: "Rob Winters",
    role: "Founder, PodOps",
    rating: 5,
  },
  {
    quote:
      "They have been a good company to work with. They provide valuable insights and try to understand needs.",
    name: "Tobi H",
    role: "Owner, Think First",
    rating: 5,
  },
  {
    quote: "The work ethic and professionalism of their whole tech team were impressive.",
    name: "Omer Shafiq",
    role: "CEO, Nordivo Oy",
    rating: 5,
  },
  {
    quote: "They approached the project like true partners, not just service providers.",
    name: "Ghilas Gabgub",
    role: "CEO, senzi",
    rating: 5,
  },
];

const SITE_URL = "https://www.exec9.com";

/**
 * The rating and total published on Exec9's Clutch profile. `reviewCount` is Clutch's real total,
 * not `TESTIMONIALS.length` — the site quotes a subset, and claiming a count that shrinks whenever
 * a quote is dropped from the carousel would misstate the corroborating source.
 */
export const CLUTCH_RATING = {
  ratingValue: "5.0",
  reviewCount: 5,
  profileUrl: "https://clutch.co/profile/exec9",
} as const;

/**
 * Attaches the quoted reviews to the sitewide Organization node by @id rather than declaring a
 * second Organization: OrganizationJsonLd already emits the full entity (including
 * aggregateRating), and re-stating name/url/rating here would put two copies of the same company
 * on one page for engines to reconcile.
 */
export const REVIEWS_JSON_LD = {
  "@context": "https://schema.org",
  "@id": `${SITE_URL}/#organization`,
  review: TESTIMONIALS.map((testimonial) => ({
    "@type": "Review",
    reviewRating: {
      "@type": "Rating",
      ratingValue: String(testimonial.rating),
      bestRating: "5",
      worstRating: "1",
    },
    author: { "@type": "Person", name: testimonial.name },
    reviewBody: testimonial.quote,
    publisher: { "@type": "Organization", name: "Clutch", url: "https://clutch.co/profile/exec9" },
  })),
};
